import React, { useState, useEffect } from 'react';
import { WifiOff, AlertCircle, RotateCw, CheckCircle } from 'lucide-react';
import { useChatStore } from '../../store/chatStore';

const ConnectionStatus: React.FC = () => {
  const { isConnected, connectionError, isReconnecting } = useChatStore();
  const [showConnected, setShowConnected] = useState(false);

  // Show "Connected" briefly when connection is established
  useEffect(() => {
    if (isConnected && !showConnected) {
      setShowConnected(true);
      const timer = setTimeout(() => {
        setShowConnected(false);
      }, 3000); // Show for 3 seconds
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isConnected, showConnected]);

  // Show temporary "Connected" message when connection is first established
  if (showConnected) {
    return (
      <div className="flex items-center gap-1.5 text-neon-lime text-xs animate-pulse">
        <CheckCircle className="h-3.5 w-3.5" />
        <span>Verbonden</span>
      </div>
    );
  }

  // After the temporary message, don't show anything when connected (clean UI)
  if (isConnected) {
    return null;
  }

  if (isReconnecting) {
    return (
      <div className="flex items-center gap-1.5 rounded-full border border-neon-cyan/25 bg-neon-cyan/[.07] px-2.5 py-0.5 text-xs text-neon-cyan">
        <RotateCw className="h-3.5 w-3.5 animate-spin" />
        <span>Opnieuw verbinden met chat...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 rounded-full border border-neon-pink/30 bg-neon-pink/10 px-2.5 py-0.5 text-xs text-neon-pink-soft">
      {connectionError ? (
        <>
          <AlertCircle className="h-3.5 w-3.5 flex-shrink-0" />
          <span className="truncate max-w-xs">
            Verbindingsfout: {connectionError.length > 40 ? connectionError.substring(0, 40) + '...' : connectionError}
          </span>
        </>
      ) : (
        <>
          <WifiOff className="h-3.5 w-3.5 flex-shrink-0" />
          <span>Verbroken van chat</span>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;